import { FormTypes } from "../../flow/flow.constants";

export const sxStyles = {
    sidebar: (type: keyof typeof FormTypes) => {
        return {
            width: type === FormTypes.SIDEBAR ? "auto" : "100%",
            height: "100%",
            backgroundColor: "white",
            ...(type === FormTypes.SIDEBAR ? { borderLeft: "1px solid #e0e0e0" } : {}),
            display: "flex",
            flexDirection: "column",
            flexShrink: 0,
            // Target the Marionette-rendered sidebar structure
            "& > div": {
                display: "flex",
                flexDirection: "column",
                height: "100%"
            },
            // Make the main content area scrollable
            "& .sidebar-content, & .component-sidebar-content": {
                flex: 1,
                overflow: "auto"
            },
            // Fix the footer at the bottom
            "& .sidebar-footer, & .component-sidebar-footer, & .footer": {
                position: "sticky",
                bottom: 0,
                backgroundColor: "white",
                borderTop: "1px solid #e0e0e0",
                zIndex: 10,
                flexShrink: 0
            },
            "& .sidebar-form": {
                height: "100%"
            },
            "& .sidebar-box": {
                overflowY: "auto",
                overflowX: "hidden",
                "& .grouped-property-template-fields": {
                    margin: "-16px",
                    marginTop: "0px"
                },
                "& .with-preview-button, & .with-metadata-modal-button": {
                    float: "right",
                    marginBottom: "16px !important",
                    marginTop: "-16px !important"
                }
            },
            "& .sidebar-actions": {
                display: "flex",
                flexDirection: "column",
                justifyContent: "end",
                height: "60px !important",
                alignItems: "center",
                padding: "8px !important",
                marginBottom: "4px !important",
                ...(type === FormTypes.MODAL ? { border: "none !important" } : {}),
                "& > div": { width: "100%" }
            },
            "& .from-control-container-title": {
                display: "none"
            },
            // Hide preview and metadata buttons by default (they are shown conditionally by sidebar.js)
            "& .preview-button, & .metadata-modal-button": {
                display: "none"
            },
            // Show buttons when parent has the appropriate class
            "& .with-preview-button .preview-button, & .with-metadata-modal-button .metadata-modal-button": {
                display: "block"
            },
            // Hide exceptions container when it has the hidden class
            "& .exceptions-container.hidden": {
                display: "none"
            },
            "& .exceptions-container": {
                position: "relative",
                overflow: "hidden",
                padding: "0 16px",
                margin: "0px 12px",
                borderRadius: "8px",
                background: "#48525C",
                color: "white",
                width: "auto !important",

                "& .clear-button": {
                    position: "absolute",
                    top: "10px",
                    right: "16px",
                    color: "white !important"
                },
                "& .exception-summary": {
                    margin: "4px"
                },
                "& .exception-items": {
                    display: "flex",
                    flexDirection: "column",
                    "& ul": {
                        marginBottom: 0
                    }
                },
                "& .exception": {
                    display: "flex",
                    flexDirection: "column",
                    "& .text-with-icon": {
                        height: "24px",
                        lineHeight: "43px"
                    },
                    "& h1, & h3, & h4": {
                        color: "white !important"
                    },
                    "& .exception-title": {
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "8px",
                        paddingRight: "28px",
                        "& .exception-title-name": {
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            minWidth: 0,
                            "& .exception-title-text": {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                minWidth: 0
                            }
                        }
                    },
                    "& .exception-info": {
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "8px"
                    },
                    "& .exception-btn-wrap": {
                        display: "flex",
                        marginTop: "8px",
                        "& .toggle-link": {
                            display: "flex",
                            gap: "4px",
                            padding: "0px 4px"
                        },
                        "& img": {
                            width: "8px"
                        }
                    },
                    "& .exception-svg": {
                        width: "18px",
                        height: "18px"
                    },
                    "& .exception-message": {
                        position: "relative",
                        maxHeight: "100px",
                        overflow: "auto",
                        overflowWrap: "anywhere",
                        "&.expanded": {
                            maxHeight: "unset"
                        }
                    }
                },
                "& .details": {
                    display: "none",
                    "& h4": {
                        color: "white"
                    },
                    "& .details-content": {
                        overflowWrap: "anywhere"
                    }
                },
                "& .crud-exception-view": {
                    padding: "10px 0 30px 10px",
                    "& .details": {
                        paddingTop: "10px"
                    }
                }
            },
            ".metadatabrowser-container": {
                "& .from-control-container-title": {
                    display: "flex",
                    flexDirection: "row-reverse"
                }
            }
        };
    },
    collapseIcon: {
        fill: "none",
        width: "24px",
        height: "24px",
        cursor: "pointer"
    },
    appSettings: {
        height: "100%",
        width: "100%",
        overflow: "auto",
        position: "relative",
        "& .tabs-box": {
            padding: "16px",
            paddingBottom: "0px"
        },
        "& .actions": {
            margin: "8px !important",
            height: "60px !important",
            padding: "12px !important"
        }
    }
};
